<template>
  <Modal v-model="showModal" :transition-names="['none','none']" width="380" lock-scroll scrollable draggable
         :closable="false" :mask="false" :maskClosable="false">
    <p slot="header" style="color: #f60; text-align: center">
      <Icon type="md-information-circled"></Icon>
      <span>{{ title }}</span>
    </p>
    <div>
      <Input v-model="descr" placeholder="请输入关键词" clearable style="width: 100%" @on-change="Search(descr)"/>
      <Table height="400" style="margin-top: 10px" :columns="columns" :data="data" stripe highlight-row
             @on-row-click="rowClick"></Table>
    </div>
  </Modal>
</template>
<script>
import {Modal, Input, Table} from 'view-design'

export default {
  components: {
    Modal,
    Input,
    Table,
  },
  data() {
    return {
      showModal: false,
      title: '常用语选择',
      descr: '',
      workType: 1,
      allData: [],
      data: [],
      columns: [
        {
          title: '问题描述',
          minWidth: 170,
          align: 'left',
          key: 'descr',
        },
      ],
    }
  },
  async created() {
    await this.loadData()
  },
  mounted() {
  },
  methods: {
    open() {
      this.showModal = true
    },
    close() {
      this.showModal = false
    },
    selectText(val) {
      if (this.workType === 1) {
        // 选择文本
        this.getText && this.getText(val + '\n')
      } else if (this.workType === 2) {
        // 选择文本
        this.getText2 && this.getText2(val + '\n')
      } else if (this.workType === 3) {
        // 选择文本
        this.getText3 && this.getText3(val + '\n')
      }
    },
    rowClick(row) {
      // 点击选择行
      this.selectText(row.descr)
    },
    async loadData(workType) {
      this.workType = workType
      let q = {}
      q.workType = workType
      let res = await $utils.api.load('/admin/system/common/noPageList', q)
      if (res) {
        if (res.code > 0) {
          let data = res.rows
          let list = data || []
          this.allData = list
          this.data = list
        }
      }
    },
    Search(descr) {
      let keyword = this.descr
      let allData = this.allData
      let newData = []
      for (let index = 0; index < allData.length; index++) {
        let item = allData[index] || {}
        let descrOld = item.descr
        if (descrOld.indexOf(keyword) != -1) {
          newData.push(item)
          this.data = newData
        }
      }
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .ivu-modal-content {
  position: fixed;
  left: auto;
  right: 10px;
}
</style>
